<template>
  <div class="section-wrap section-column-wrap" id="app">
    <div class="section-column section-content word-bind-input-container">
      <div class="field">
        <label for="column-a">Prefix</label>
        <textarea name="column-a" v-model="wordColumnA" type="text-area" rows="4" cols="50">
        </textarea>
      </div>
      <div class="field">
        <label for="column-b">Keyword</label>
        <textarea name="column-b" v-model="wordColumnB"  type="text-area" rows="4" cols="50">
        </textarea>
      </div>
      <div class="field">
        <label for="column-c">Suffix</label>
        <textarea name="column-b" v-model="wordColumnC" type="text-area" rows="4" cols="50">
        </textarea>
      </div>
    </div>
      <WordBind
      :wordColumnA="wordColumnA"
      :wordColumnB="wordColumnB"
      :wordColumnC="wordColumnC"
    />
  </div>
</template>
<script>
import WordBind from './components/WordBind.vue';

export default {
  name: 'App',
  components: {
    WordBind,
  },
  data() {
    return {
      wordColumnA: '',
      wordColumnB: '',
      wordColumnC: '',
    };
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
  max-width: 1200px;

  .word-bind-input-container {
    display: flex;
  }
}

</style>
